import * as React from 'react';
import { useFormattedTemplate } from '../../../hooks/useFormattedTemplate';

import { WaitIcon } from '../../icons';
import styles from './ClosedOverlay.module.scss';

interface ClosedOverlayProps {
  title: string;
  description: string;
}

const ClosedOverlay: React.FC<ClosedOverlayProps> = ({
  title,
  description,
}) => {
  const formattedTemplate = useFormattedTemplate(description, {
    className: styles.descriptionBold,
  });
  return (
    <div className={styles.overlay} data-testid="overlay-main-wrapper">
      <div className={styles.wrapper}>
        <WaitIcon />
        <p className={styles.title} data-testid="overlay-title">
          {title}
        </p>
        <div>
          <span className={styles.description}>{formattedTemplate}</span>
        </div>
      </div>
    </div>
  );
};
export default ClosedOverlay;
